import React from 'react'
import { ChangeLog } from '@/api/generated-client'
import { t } from '@/i18n'
import { formatDate } from '@/utils/date'
import styles from './ChangeLogRow.module.scss'

interface ChangeLogRowProps {
  node: ChangeLog
  onClick?: (item: any) => void
}

const ChangeLogRow: React.FC<ChangeLogRowProps> = ({
  node: changeLog,
  onClick,
}) => {
  // Safety check for undefined changeLog
  if (!changeLog) {
    return null
  }

  const getChangeTypeLabel = (type?: string) => {
    switch (type) {
      case 'CREATE':
        return t('change_type_create')
      case 'UPDATE':
        return t('change_type_update')
      case 'DELETE':
        return t('change_type_delete')
      case 'COMMENT':
        return t('change_type_comment')
      default:
        return type || ''
    }
  }

  const getChangeDescription = () => {
    if (changeLog.change_type === 'COMMENT') {
      return changeLog.change_reason || ''
    }

    const fieldName = changeLog.field_name || ''
    const oldValue = changeLog.old_value || t('empty')
    const newValue = changeLog.new_value || t('empty')

    if (changeLog.change_type === 'CREATE') {
      return t('change_log_created_field', {
        field: fieldName,
        value: newValue,
      })
    }

    if (changeLog.change_type === 'DELETE') {
      return t('change_log_deleted_field', {
        field: fieldName,
        value: oldValue,
      })
    }

    if (changeLog.change_type === 'UPDATE') {
      return t('change_log_updated_field', {
        field: fieldName,
        oldValue,
        newValue,
      })
    }

    return changeLog.change_reason || ''
  }

  return (
    <div className={styles['change-log-entry']}>
      <div className={styles['change-log-meta']}>
        <div className={styles['change-log-type-badge']}>
          <span
            className={`${styles.badge} ${
              styles[changeLog.change_type?.toLowerCase() || 'comment']
            }`}
          >
            {getChangeTypeLabel(changeLog.change_type)}
          </span>
        </div>
        <div className={styles['change-log-info']}>
          <div className={styles['change-log-user']}>
            {changeLog.changed_by || t('system')}
          </div>
          <div className={styles['change-log-date']}>
            {changeLog.creation_time && formatDate(changeLog.creation_time)}
          </div>
        </div>
      </div>
      <div className={styles['change-log-content']}>
        <div className={styles['change-log-description']}>
          {getChangeDescription()}
        </div>
      </div>
    </div>
  )
}

export default ChangeLogRow
